import {debounce} from 'lodash';
import {useCallback, useEffect, useState} from 'react';

export const useTimedDeactivation = props => {
    const {timeout = 10000, onActivate = () => {}, ignoreTimeout = 0} = props,
        [ignore, setIgnore] = useState(false),
        [isActive, setActive] = useState(false);

    const debouncedSetActive = useCallback(
        debounce(active => {
            if (!active) {
                setIgnore(true);
            }
            setActive(active);
        }, timeout),
        [timeout]
    );
    useEffect(() => () => debouncedSetActive.cancel(), [debouncedSetActive]);

    const handleMouseActivity = useCallback(() => {
        if (!ignore) {
            setActive(true);
            debouncedSetActive(false);
            onActivate();
        }
    }, [onActivate, debouncedSetActive]);

    useEffect(() => {
        if (ignore) {
            let timeout = setTimeout(() => setIgnore(false), ignoreTimeout);
            return () => clearTimeout(timeout);
        }
    });

    return [isActive, setActive, handleMouseActivity];
};
